import { SVGProps, Ref, forwardRef } from 'react';

export const FlagOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.134c-2.75-.982-5.5-1.964-10 0V23h1.8v-5.796c3.474-1.026 5.837-.182 8.2.662 2.75.982 5.5 1.964 10 0V3l-.612-.612q-.615.24-1.188.408c-3.474 1.026-5.837.182-8.2-.662m-4.482.69c-1.033-.08-2.23.025-3.718.537v11.976c1.446-.371 2.76-.466 3.995-.37 1.835.14 3.403.701 4.738 1.178l.072.026c1.4.5 2.558.904 3.877 1.005 1.034.08 2.23-.025 3.718-.537V4.663c-1.446.371-2.76.466-3.995.37-1.835-.14-3.403-.701-4.738-1.178l-.072-.026c-1.4-.5-2.558-.904-3.877-1.005"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlagOutlinedSize24Glyph.displayName = 'FlagOutlinedSize24Glyph';
